<div class="autocont f-black roboto-l f-bmed pull-left vcenter">
    <div class="tabcell">
        Ciclo de Facturaci&oacute;n
    </div>
</div>
<div class="autocont f-black roboto-l f-bmed othrdef pull-right vcenter">
    <div class="tabcell">
        {{this.cycleDateField}}
    </div>
</div>
<div class="basicrow m-top-ii">
    <div class="logline full"></div>
</div>
<div class="basicrow m-top-i mbott bot-mob">
    <div class="difftabs">
        <div (click)="this.statusChangeData(1);"
            [className]="this.selTabData===1 ? 'tab2 difft-def on ' : 'tab2 difft-def'">
            Plan Base
        </div>
        <div (click)="this.statusChangeData(2);"
            [className]="this.selTabData===2 ? 'tab2 difft-def on ' : 'tab2 difft-def'">
            Roaming
        </div>
        <div (click)="this.statusChangeData(3);"
            [className]="this.selTabData===3 ? 'tab2 difft-def on ' : 'tab2 difft-def'">
            Paquetes Adicionales
        </div>
    </div>
</div>
<div id="viewPlanBase" class="basicrow f-black roboto-r f-reg"
    [ngStyle]="{'display':this.selTabData === 1 ? 'block' : 'none' }">
    <div>
        <div class="basicrow">
            <div *ngFor="let usage of this.usage2[this.index].subscriber; let j = index">
                <div *ngIf="usage.type=='PL-ACT'">
                    <div class="text-center left">
                        <div id="borde1">
                            <app-graphic [indexI]="this.index" [indexJ]="j"></app-graphic>
                        </div>
                    </div>
                    <div class="right">
                        <div class="basicrow">
                            <div class="userinfo full">
                                <div class="basicrow">
                                    <div class="redstat">
                                        <div class="autorow roboto-r pull-left">
                                            {{usage.DPlanName}}
                                        </div>
                                    </div>
                                    <div class="redstat m-top-ii">
                                        <div class="autorow roboto-r pull-left">
                                            Has consumido
                                        </div>
                                        <div class="autorow roboto-b pull-right">
                                            <span class="f-red">{{usage.iDLocalText}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="basicrow m-top">
                            <div class="logline full"></div>
                        </div>
                        <div class="basicrow m-top-ii">
                            <div class="twostats">
                                <div class="statrectdef redstat"></div>
                                <div class="autocont f-mini roboto-r f-black vcenter">
                                    <div class="tabcell">
                                        Consumidos ({{usage.iDLocalText}})
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="basicrow">
                <div class="logline full"></div>
            </div>
            <div class="basicrow m-top-i button-compra m-bott-ii">
                <div class="caja-compra">
                    <a routerLink="/datapurchase" class="btns blue vcenter">
                        <span class="tabcell">
                            Compra de Paquetes Adicionales&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
                        </span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>
<div id="viewRoaming" class="basicrow f-black roboto-r f-reg"
    [ngStyle]="{'display':this.selTabData === 2 ? 'block' : 'none' }">
    <div class="basicrow">
        <div *ngFor="let usage of this.usage2[this.index].subscriber; let j = index">
            <div *ngIf="usage.type=='DR'">
                <div class="text-center left">
                    <div id="borde1">
                        <app-graphic [indexI]="this.index" [indexJ]="j"></app-graphic>
                    </div>
                </div>
                <div class="right">
                    <div class="basicrow">
                        <div class="userinfo full">
                            <div class="basicrow">
                                <div class="redstat">
                                    <div class="autorow roboto-r pull-left">
                                        Plan Base
                                    </div>
                                    <div class="autorow roboto-b pull-right">
                                        {{usage.DPlanName}}
                                    </div>
                                    <div class="autorow roboto-r pull-left">
                                    </div>
                                </div>
                                <div class="redstat m-top-ii">
                                    <div class="autorow roboto-r pull-left">
                                        Has consumido
                                    </div>
                                    <div class="autorow roboto-b pull-right">
                                        <span class="f-red"> {{usage.iDLocalText}} </span>de {{usage.DLocalTop}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="basicrow m-top">
                        <div class="logline full"></div>
                    </div>
                    <div class="basicrow m-top-ii">
                        <div class="twostats">
                            <div class="statrectdef redstat"></div>
                            <div class="autocont f-mini roboto-r f-black vcenter">
                                <div class="tabcell">
                                    Consumidos ({{usage.iDLocalText}})
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="this.usage2[this.index].countDR==0">
            <div class="userinfo full" tyle=" width:100%; height: auto;">
                <div class="basicrow" style="width: 100%;height: auto;">
                    <div class="basicrow f-bmed roboto-b m-bott usag-text bot-mob"
                        style="line-height: 2.5; text-align: center">
                        Actualmente no cuentas con Servicio de Roaming
                    </div>
                </div>
            </div>
        </div>
        <div class="basicrow">
            <div class="logline full"></div>
        </div>
        <div class="basicrow m-top-i button-compra m-bott-ii">
            <div class="caja-compra">
                <a routerLink="/datapurchase" class="btns blue vcenter">
                    <span class="tabcell">
                        Compra de Paquetes Adicionales&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
                    </span>
                </a>
            </div>
        </div>
    </div>
</div>
<div id="viewPackages" class="basicrow f-black roboto-r f-reg"
    [ngStyle]="{'display':this.selTabData === 3 ? 'block' : 'none' }">
    <div class="basicrow" style=" width:100%; height: auto;">
        <div *ngFor="let usage of this.usage2[this.index].subscriber; let j = index">
            <div *ngIf="usage.type=='PQ-AD'">
                <div class="text-center left">
                    <div id="borde1">
                        <app-graphic [indexI]="this.index" [indexJ]="j"></app-graphic>
                    </div>
                </div>
                <div class="right">
                    <div class="basicrow">
                        <div class="userinfo full">
                            <div class="basicrow">
                                <div class="redstat">
                                    <div class="autorow roboto-r pull-left">
                                        Paquetes Adicionales
                                    </div>
                                    <div class="autorow roboto-b pull-right">
                                        {{usage.DPlanName}}
                                    </div>
                                </div>
                                <div class="redstat m-top-ii">
                                    <div class="autorow roboto-r pull-left">
                                        Has consumido
                                    </div>
                                    <div class="autorow roboto-b pull-right">
                                        <span class="f-red">{{usage.iDLocalText}}</span> de {{usage.DLocalTop}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="basicrow m-top">
                        <div class="logline full"></div>
                    </div>
                    <div class="basicrow m-top-ii">
                        <div class="twostats">
                            <div class="statrectdef redstat"></div>
                            <div class="autocont f-mini roboto-r f-black vcenter">
                                <div class="tabcell">
                                    Consumidos ({{usage.iDLocalText}})
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="this.usage2[this.index].countPQAD==0">
        <div class="userinfo full" tyle=" width:100%; height: auto;">
            <div class="basicrow" style="width: 100%;height: auto;">
                <div class="basicrow f-bmed roboto-b m-bott usag-text bot-mob">
                    Actualmente no cuentas con paquetes adicionales
                </div>
            </div>
        </div>
    </div>
    <div class="basicrow">
        <div class="logline full"></div>
    </div>
    <div class="basicrow m-top-i button-compra m-bott-ii">
        <div class="caja-compra">
            <a routerLink="/datapurchase" class="btns blue vcenter">
                <span class="tabcell">
                    Compra de Paquetes Adicionales&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
                </span>
            </a>
        </div>
    </div>
</div>